<template>
  <div class="xscontainer user-registration-page">
    <div class="lloiiere">国际数据治理协会诚挚的邀请您的加入，希望未来的您可以在此能够获得更大的提升，也希望您为全球数据治理行业提供更多的能力输出!</div>
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <div class="nmkerwer">
        <el-form-item label="姓名" prop="xingming">
          <el-input type="input" v-model="ruleForm.xingming" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idcard">
          <el-input type="input" v-model="ruleForm.idcard" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="sjh">
          <el-input type="input" v-model="ruleForm.sjh" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="youxiang">
          <el-input type="input" v-model="ruleForm.youxiang" autocomplete="off"></el-input>
        </el-form-item>
      </div>
      <div class="nmkerwer">
        <el-form-item label="所在公司" prop="suozaigongsi">
          <el-input type="input" v-model="ruleForm.suozaigongsi" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="岗位" prop="gangwei">
          <el-input type="input" v-model="ruleForm.gangwei" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="擅长领域" prop="scly">
          <el-input type="input" v-model="ruleForm.scly" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="个人介绍" prop="grjs">
          <el-input type="textarea" v-model="ruleForm.grjs" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button @click="resetForm('ruleForm')">重置</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </div>
    </el-form>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('年龄不能为空'));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value < 18) {
            callback(new Error('必须年满18岁'));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        xingming:'',
        idcard:'',
        sjh:'',
        youxiang:'',
        gangwei:'',
        suozaigongsi:'',
        scly:'',
        grjs:'',

      },
      rules: {
        xingming: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$|^[1-9]\d{5}\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}$/,  message: '请输入正确的身份证号', trigger: ['blur', 'change'] }
        ],
        sjh: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {  pattern: /^1[3-9]\d{9}$/,  message: '请输入正确的手机号', trigger: ['blur'] }
        ],
        youxiang: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        gangwei: [
          { required: true, message: '请输入岗位', trigger: 'blur' },
        ],
        suozaigongsi: [
          { required: true, message: '请输入所在公司', trigger: 'blur' },
        ],
        scly: [
          { required: true, message: '请输入擅长领域', trigger: 'blur' },
        ],
        grjs: [
          { required: true, message: '请输入个人介绍', trigger: 'blur' },
        ]
      },
      fwcishu:0
    };
  },
  created() {
    this.tongji('申请入会');
  },
  methods: {
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('您确认提交吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var that = this;
            this.$ajax
                .post(this.GLOBAL.sys_addr + '/huiyuan/tHuiyuan/add',this.ruleForm)
                .then(function (response) {
                  if (response.data.code == 200) {
                    that.$notify.success({ position: 'bottom-right', title: '提示', message: '会员申请已提交，请耐心等待审核' });
                  } else {
                    that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
                  }
                });
          }).catch(() => {
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>


<style scoped>
.user-registration-page {
  width: 80%;
  display: flex;
  flex-direction: column;
  margin: 2rem 0;
  gap:2rem;
  justify-content: center;
  align-items: center;
}
.demo-ruleForm{
  width: 100%;
  display: flex;
  gap: 2rem;
  justify-content: center;
}
.nmkerwer{
  width: 40%;
}
.lloiiere{
  width: 100%;
  font-size: 14px;
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
}
</style>
